// extracted by mini-css-extract-plugin
export default {"addedList":"webPageAddedEvent_addedList__grL1x","scroll":"webPageAddedEvent_scroll__YYIP1"};